export const authorCode = state => state.authorCode
export const userInfo = state => state.userInfo
export const cancalActiveName = state => state.cancalActiveName
export const tasksInfoData = state => state.tasksInfoData
export const tasksAcceptancesStatistics = state => state.tasksAcceptancesStatistics
export const tasksAcceptancesList = state => state.tasksAcceptancesList
export const tasksAcceptancesData = state => state.tasksAcceptancesData
